import { ExportTypeBaseService } from '/@/modules/export/services/ExportTypeBaseService';
import Lang from '/@/modules/core/app/services/Lang';
import { getters } from '/@/modules/core/app/helpers/store';

export class PurchaseSummaryExportService extends ExportTypeBaseService {
  /**
   * @var {String}
   */
  dealName;

  /**
   * @return {string}
   */
  getFilename() {
    this.dealName = getters.export.getData().hubSpotDeal.propertyDealname;
    return `${this.dealName.replaceAll(' ', '-')}-purchase-summary.pdf`;
  }

  /**
   * @return {*}
   */
  getSnackBarTitle() {
    return Lang.t('estate.the-summary-now');
  }

  async download() {
    return this.resource.downloadWithToken(this.type, this.params);
  }
}

export default new PurchaseSummaryExportService();
